import {useTheme} from '@mui/material';

interface QuantityPickerIconsProps {
  width?: number;
  height?: number;
  fillBg?: string;
  fillRect?: string;
  disabled?: boolean;
  viewBox?: string;
  rx?: string;
}

export const MinusIconWithBg = ({
  width = 32,
  height = 32,
  viewBox = '0 0 32 32 ',
  fillBg = '#FFFFFF',
  fillRect = '#F22643',
  disabled = false,
  rx = '16'
}: QuantityPickerIconsProps) => {
  const theme = useTheme();

  const _fillBg = !disabled ? fillBg : theme.palette.grey[400];
  const _fillRect = !disabled ? fillRect : theme.palette.grey[200];
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={width} height={height} rx={rx} fill={_fillRect} />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.667 16C25.667 16.3344 25.5039 16.6292 25.2599 16.8289C25.0188 17.0263 24.7096 17.125 24.4032 17.125H7.60067C7.29433 17.125 6.98515 17.0263 6.74396 16.8289C6.49998 16.6292 6.33691 16.3344 6.33691 16C6.33691 15.6656 6.49998 15.3708 6.74396 15.1711C6.98515 14.9737 7.29432 14.875 7.60067 14.875H24.4032C24.7096 14.875 25.0188 14.9737 25.2599 15.1711C25.5039 15.3708 25.667 15.6656 25.667 16Z"
        fill={_fillBg}
      />
    </svg>
  );
};
